import { render, staticRenderFns } from "./PopupFiltersTasks.vue?vue&type=template&id=1f8290ba"
import script from "./PopupFiltersTasks.vue?vue&type=script&lang=ts"
export * from "./PopupFiltersTasks.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports